(() => {
  if (window.__auFreeProductsSync) return;
  window.__auFreeProductsSync = true;

  const ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  const url = (p) => (ROOT + p).replace("//", "/");
  const SECTION = "au-free-products-data";

  let running = false;
  let queued = false;
  let latestCart = null;
  let checkedKeys = null;
  try {
    checkedKeys = sessionStorage.getItem("au-free-products-keys");
  } catch {}

  const currentCart = async () => {
    if (latestCart) return latestCart;
    const count = document
      .querySelector("[data-cart-count]")
      ?.getAttribute("data-cart-count");
    if (count === "0") return { items: [] };
    if (typeof window.__auGetCart === "function") {
      try {
        return await window.__auGetCart();
      } catch {}
    }
    return null;
  };

  const readLines = async () => {
    const r = await fetch(
      `${url("")}?section_id=${SECTION}&cb=${Date.now()}`,
      { credentials: "same-origin" }
    );
    if (!r.ok) throw new Error("Cart metadata section read failed: " + r.status);
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.getElementById(SECTION);
    if (!el) throw new Error("Cart metadata section data is missing");
    const data = JSON.parse(el.textContent);
    if (!data || !data.lines || typeof data.lines !== "object" || Array.isArray(data.lines)) {
      throw new Error("Cart metadata section lines are invalid");
    }
    return data.lines;
  };

  const lineProperties = async () => {
    const r = await fetch(url("cart.js"), { credentials: "same-origin" });
    if (!r.ok) return new Map();
    const fresh = await r.json();
    return new Map(fresh.items.map((item) => [item.key, item.properties]));
  };

  const patch = async (key, value, currentProperties) => {
    const properties = Object.assign({}, currentProperties, {
      _free_products: value,
    });
    const response = await fetch(url("cart/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, properties }),
    });
    if (!response.ok) throw new Error("Cart property update failed: " + response.status);
  };

  const sync = async () => {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      const cart = await currentCart();
      const cartKeys = cart ? cart.items.map((i) => i.key).sort().join(",") : null;
      if (cart && (!cart.items.length || cartKeys === checkedKeys)) return;
      const lines = await readLines();
      const keys = Object.keys(lines);
      if (keys.length) {
        const props = await lineProperties();
        let patched = false;
        for (const key of keys) {
          if (!props.has(key)) continue;
          await patch(key, lines[key], props.get(key));
          patched = true;
        }
        if (patched) document.dispatchEvent(new CustomEvent("au:cart:stale"));
      } else if (cartKeys) {
        checkedKeys = cartKeys;
        try {
          sessionStorage.setItem("au-free-products-keys", cartKeys);
        } catch {}
      }
    } catch (e) {
      console.warn("[au-free-products-sync]", e);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        setTimeout(sync, 0);
      }
    }
  };

  const schedule = (() => {
    let t = null;
    return (e) => {
      const cart = e && e.detail && e.detail.cart && e.detail.cart.cart;
      if (cart && Array.isArray(cart.items)) latestCart = cart;
      clearTimeout(t);
      t = setTimeout(sync, 400);
    };
  })();

  document.addEventListener("rebuy:cart.change", (e) => {
    const cart = e && e.detail && e.detail.cart && e.detail.cart.cart;
    if (cart && Array.isArray(cart.items)) latestCart = cart;
  });
  document.addEventListener("rebuy:smartcart.hide", schedule);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }
})();
